import React, { useState } from 'react';
import { DashboardProvider } from './context/DashboardContext';
import Dashboard from './components/Dashboard';
import './styles/index.css';

function App() {
  const [dark, setDark] = useState(false);

  return (
    <div className={dark ? 'app dark' : 'app'}>
      <DashboardProvider>
        <Dashboard dark={dark} setDark={setDark} />
      </DashboardProvider>
    </div>
  );
}

export default App;
